module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_PL-a0d1c0a05bbc8a6f05a4b1e54136e1a9.svg";